module.exports = __webpack_public_path__ + "static/media/stripe_customers.c226d925.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/detailer/stripe_customers.jpg
// module id = 657
// module chunks = 0